module.exports = __webpack_public_path__ + "img/IMG_1962_P_BlackMatted.ef544239.jpg";